import { createInertiaApp } from '@inertiajs/svelte'
import  { mount } from 'svelte';
import Layout from '../lib/layouts/Layout.svelte'
import AppLayout from '../lib/layouts/AppLayout.svelte'   // ← 改成 import AppLayout
createInertiaApp({
  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,

  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.svelte', {
      eager: true,
    })
    const page = pages[`../pages/${name}.svelte`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.svelte'`)
    }

    // To use a default layout, import the Layout component
    // and use the following line.
    // see https://inertia-rails.dev/guide/pages#default-layouts
    //
    // return { default: page.default, layout: page.layout || Layout }

    // 优先使用页面自己导出的 layout（比如 Dashboard 的 AppLayout）
    // 如果页面没有导出 layout，才使用默认 Layout
    console.log('page.layout', page.layout);
    return {
      default: page.default,
      layout: page.layout || page.default.layout || Layout
    }
  },

  setup({ el, App, props }) {
    if (el) {
      mount(App, { target: el, props })
    } else {
      console.error(
        "Missing root element.\n\n" +
        "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
        'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.',
      )
    }
  },
})
